import { getUnauthSettings, Navigation } from "@mcleod/core";
import { AutogenLayoutOrderConfirmationHeader } from "./autogen/AutogenLayoutOrderConfirmationHeader";
import {  ClickEvent } from "@mcleod/components";

export class OrderConfirmationHeader extends AutogenLayoutOrderConfirmationHeader {

  override onLoad() {
   this.labelOrderSubmitMsg.caption = getUnauthSettings().company_settings["order_submit_ok"] ?? "";
  }

  buttonListViewOnClick(event: ClickEvent) {
    Navigation.navigateTo("/");
  }


  displayHoldPanel(holdWarning: any) {
    const warningText = holdWarning?.text;
    if (warningText) {
      this.panelHold.visible = true;
      this.labelHold.caption = warningText;
      this.labelHoldEmail.visible = holdWarning?.email;
      this.labelHoldEmail.caption = holdWarning?.email;
      if (holdWarning?.email && holdWarning?.subject)
        this.labelHoldEmail.link = `mailto:${holdWarning?.email}?subject=${holdWarning?.subject}`;
    }
  }
}
